import { t } from "i18next";
import i18n from "locales/i18n";
import { forwardRef } from "react";

export const ListInput = forwardRef(function ListInput(
  {
    list,
    name,
    identifier,
    disableState,
    setDisabledState,
    toEdit,
    state,
    setState,
    defaultValue,
  },
  inputRef
) {
  const lang = i18n.language;
  console.log(defaultValue);
  return (
    <>
      <select
        required
        disabled={disableState}
        className="main-input"
        selected={defaultValue ?? state[name]}
        value={defaultValue ?? state[name] ?? "0"}
        onChange={(e) => {
          setState({ ...state, [name]: e.target.value });
        }}
        name={name}
        id={name}
        placeholder="a"
        ref={inputRef}
        onBlur={() => toEdit && setDisabledState(true)}
      >
        <option disabled value="0">
          {t("choose")}
        </option>

        {list.map((li, idx) => {
          return (
            <option key={li._id ?? idx} value={li[identifier][lang]}>
              {li[identifier][lang]}
            </option>
          );
        })}
      </select>
      <label className="main-label" htmlFor={name}>
        {t(name)}
      </label>
    </>
  );
});
